import { ArrowLeft, Landmark, ShieldCheck, Wallet } from "lucide-react"
import { useWizard } from "./WizardContext"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

const paymentOptions = [
  { value: "financing", label: "Interested in financing", desc: "Low monthly payments available", icon: Landmark },
  { value: "insurance", label: "Working with insurance", desc: "Storm damage or insurance claim", icon: ShieldCheck },
  { value: "out-of-pocket", label: "Paying out of pocket", desc: "Direct payment at completion", icon: Wallet },
]

export default function PaymentStep() {
  const { state, setPayment, nextStep, prevStep } = useWizard()

  const handleSelect = (value: string) => {
    setPayment(value)
    nextStep()
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground tracking-tight">
          How are you planning to pay?
        </h2>
        <p className="text-muted-foreground mt-1">
          This helps us tailor your estimate and available options.
        </p>
      </div>

      <div className="grid gap-3">
        {paymentOptions.map((option) => {
          const isSelected = state.paymentMethod === option.value
          const Icon = option.icon
          return (
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={cn(
                "flex items-center gap-4 p-5 border-2 rounded-xl text-left transition-all duration-200 hover:border-primary/50 group",
                isSelected
                  ? "border-primary bg-primary/5 ring-2 ring-primary/20"
                  : "border-muted",
              )}
            >
              <div
                className={cn(
                  "w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors",
                  isSelected
                    ? "bg-primary text-white"
                    : "bg-muted text-muted-foreground group-hover:text-foreground",
                )}
              >
                <Icon className="w-6 h-6" />
              </div>
              <div>
                <div className="font-bold text-foreground">{option.label}</div>
                <div className="text-sm text-muted-foreground mt-0.5">{option.desc}</div>
              </div>
            </button>
          )
        })}
      </div>

      <Button variant="outline" onClick={prevStep} className="h-12 px-6 rounded-xl font-semibold">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back
      </Button>
    </div>
  )
}
